import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const api = process.env.REACT_APP_BANKVERIFY_URL;
const url = process.env.REACT_APP_BANKVERIFY_URL;

export const MandateFileUpLoad = async (mandateFile, excelFile, bank, setIsloading, setSuccessMsg, setError, setOpen, refuntion) => {
  setIsloading(true);
  const formData = new FormData();
  // files.forEach((file) => {
  //     if (file.type.includes('spreadsheet') || file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
  //       formData.append('excel_file', file);
  //     } else if (file.type.includes('pdf') || file.type.includes('image')) {
  //       formData.append('bank_mandate_file', file);
  //     }
  //   });
  formData.append('excel_file', excelFile);
  formData.append('bank_mandate_file', mandateFile);

  // Append the selected product (bank)
  formData.append('product', bank);
  try {
    await axios
      .post(`${api}mandate/api/v1/mandate_file_upload`, formData, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            setOpen(false);
            refuntion();
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const MandateFiles = async (page, rowsPerPage, setIsloading, setSuccess, setError, setTotalCount, BankName,MandateType) => {
  setIsloading(true);
  const params = new URLSearchParams();
  params.append('product', BankName);
  params.append('mandate_type', MandateType);
  params.append('page', page);
  params.append('limit', rowsPerPage);
  try {
    await axios
      .get(`${api}mandate/api/v1/mandate_files`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.data);
          setIsloading(false);
          setTotalCount(res.data.total_records);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const MandateAgregatedData = async (selected, setIsloading, setMandateData, setError) => {
  setIsloading(true);
  const params = new URLSearchParams();
  params.append('mandate_type', selected);
  try {
    await axios
      .get(`${api}mandate/api/v1/mandate_aggregated_data`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setMandateData(res.data);
        setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

// export const MandateFileDownload = async(id,setIsloading,setSuccessMsg,setError) =>{
//   setIsloading(true);
//     const params = new URLSearchParams();
//     params.append('mandate_id', id);
//   try{
//     await axios.get(`${api}mandate/api/v1/file_downoad`,{
//       headers: {
//         Authorization: `Bearer ${sessionStorage.getItem('token')}`
//       },params
//     })
//     .then((res)=>{
//       if(res.status===200){
//         setSuccessMsg(res.data.message)
//         setIsloading(false);
//       }
//     })
//     .catch((error)=>{
//       TokenLogout(error);
//         setError(error.response ? error.response.data.error : 'Something went wrong');
//         setIsloading(false);
//     })
//   }catch (error) {
//     TokenLogout(error);
//     setError(error.response ? error.response.data.error : 'Something went wrong');
//     setIsloading(false);
//   }
// }

export const MandateFileDownload = async (id, setIsLoading, setSuccessMsg, setError) => {
  setIsLoading(true);
  const params = new URLSearchParams();
  params.append('mandate_id', id);

  try {
    const response = await axios.get(`${api}mandate/api/v1/file_downoad`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      params,
      responseType: 'blob' // Important: Set response type to blob
    });

    if (response.status === 200) {
      // Create a download link for the ZIP file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Set filename from content-disposition header (if available)
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'mandate_files.zip';
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // Clean up the URL

      // Show success message
      setSuccessMsg('File downloaded successfully');
    }
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  } finally {
    setIsLoading(false);
  }
};

// surrender

export const surreenderMandateId = async (bank_name, setIsLoading, setSuccess, setError) => {
  setIsLoading(true);
  const params = new URLSearchParams();
  params.append('product', bank_name);

  try {
    await axios
      .get(`${api}mandate/api/v1/mandates`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.mandate_ids);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const GetMandateSummary = async (mandate_id, setIsLoading, setMandateDetails, setError) => {
  setIsLoading(true);
  const params = new URLSearchParams();
  params.append('mandate_id', mandate_id);
  try {
    await axios
      .get(`${api}mandate/api/v1/get_mandate_summary`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setMandateDetails(res.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const SurrenderMandate = async (Data, setSubIsloading, setSuccessMsg, setError, setSurrenderRequest, refunction) => {
  setSubIsloading(true);
  try {
    await axios
      .post(
        `${api}mandate/api/v1/surrender_mandate`,
        { mandate_id: Data.mandate_id, remarks: Data.remarks },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setSubIsloading(false);
          setTimeout(() => {
            setSurrenderRequest(false);
            refunction();
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setSubIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setSubIsloading(false);
  }
};

export const SurrenderMandateList = async (page, rowsPerPage, setIsLoading, setSuccess, setError, setTotalCount,bank) => {
  setIsLoading(true);
  const params = new URLSearchParams();
  // params.append('status', 'pending');
  params.append('page', page);
  params.append('limit', rowsPerPage);
  params.append('bank_name', bank);

  try {
    await axios
      .get(`${api}mandate/api/v1/get_surrendered_mandates`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.data);
          setIsLoading(false);
          setTotalCount(res.data.total_records);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const SurrenderMandateListApprove = async (id, setIsLoadingStatus, setSuccessMsg, setError, refunction) => {
  setIsLoadingStatus(true);
  const params = new URLSearchParams();
  params.append('mandate_id',id);
  id;

  try {
    await axios
      .post(
        `${api}mandate/api/v1/approve_surrendered_mandates`,
        {'Data':'data'},
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          params
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsLoadingStatus(false);
          setTimeout(() => {
            refunction();
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsLoadingStatus(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsLoadingStatus(false);
  }
};

export const FiBankListM = async (setIsloadingBank,setBankList) => {
  setIsloadingBank(true)

  try {
    await axios
      .get(`${url}finvesta-user/fi_banks_list`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setBankList(res.data);
          setIsloadingBank(false)
        }
      })
      .catch((error) => {
        TokenLogout(error)
        console.log(error);
        setIsloadingBank(false)
      });
  } catch (error) {
    TokenLogout(error)
    console.log(error);
    setIsloadingBank(false)
  }
};